module.exports = __webpack_public_path__ + "static/media/shuttleBanner2.3f562c1a.png";